module.exports = __webpack_public_path__ + "static/media/icon6.894d468b.svg";